/// <reference path="../../../Modules/Attr/Dialog/NoboxEntityDialog.ts" />
namespace Nobox.CustomFields {

    @Serenity.Decorators.registerClass()
    //@Serenity.Decorators.panel()
    export class CustomfieldsDialog extends NoboxEntityDialog<CustomfieldsRow, any> {
        protected getFormKey() { return CustomfieldsForm.formKey; }
        protected getIdProperty() { return CustomfieldsRow.idProperty; }
        protected getLocalTextPrefix() { return CustomfieldsRow.localTextPrefix; }
        protected getNameProperty() { return CustomfieldsRow.nameProperty; }
        protected getService() { return CustomfieldsService.baseUrl; }
        protected getDeletePermission() { return CustomfieldsRow.deletePermission; }
        protected getInsertPermission() { return CustomfieldsRow.insertPermission; }
        protected getUpdatePermission() { return CustomfieldsRow.updatePermission; }
        protected form = new CustomfieldsForm(this.idPrefix);
        protected dataList: Array<Nobox.form> = [];

        protected checkElm = `<input type="checkbox" class="editor mr-1 checkField" name="Show" title="Show" DataCheck>`;
        protected inpElm = `<div class="form-control bgCustom col text-ellipsis"><span>DataValue</span>DataRequired</div>`;
        protected CategoryElm = `<div class="form-control col text-ellipsis"><div class="chat-sap mx-0 py-0" style="margin: 2px 0;"><div class="chat-sap-meta" style="display: table-row;"><span><b style="color:#344357;">DataCategory :&nbsp;</b></span></div></div></div>`;
        protected btnSettings = `<a class="btn inplace-button settingsField" title="Settings"><b><i class="fa fa-cog"></i></b></a>`;
        protected btnDelete = `<a class="btn inplace-button deleteField" title="Delete"><b><i class="fa fa-trash"></i></b></a>`;
        protected btnUp = `<a class="btn inplace-button upField disabled" title="Move to top"><b><i class="fa fa-chevron-up"></i></b></a>`;
        protected btnDown = `<a class="btn inplace-button downField disabled" title="Move to bottom"><b><i class="fa fa-chevron-down"></i></b></a>`;
        protected btnInfo = `<a class="btn inplace-button" tabindex="0" data-toggle="tooltip" title="This field will only appear if the form type is Order and the product field is filled in"><b><i class="fa fa-info"></i></b></a>`;

        constructor() {
            super();
            this.form.Data.getGridField().css("overflow-x", "hidden");
        }

        protected array_move(old_index, new_index) {
            if (new_index >= this.dataList.length) {
                var k = new_index - this.dataList.length + 1;
                while (k--) {
                    this.dataList.push(undefined);
                }
            }
            this.dataList.splice(new_index, 0, this.dataList.splice(old_index, 1)[0]);
            return this.dataList; // for testing
        };

        protected loadEntity(entity: CustomfieldsRow) {
            super.loadEntity(entity);
            //init
            if (this.isEditMode()) {
                this.deleteButton.remove();
                this.dataList = Q.isEmptyOrNull(entity.Data) ? [] : JSON.parse(entity.Data);
                this.renderElm();
            }
        }

        protected renderElm() {
            let elmData = this.form.Data.element;
            elmData.html("");
            var $this = this;
            if (this.dataList == null)
                this.dataList = [];

            if (this.dataList.length > 0) {
                this.dataList.forEach((yz, ind) => {
                    let elm = `<div class="field ${yz.settings.label} row px-4" data-index="${ind}">`;
                    if (yz.settings.field == "category") {
                        elm += this.CategoryElm.replace("DataCategory", yz.settings.label);
                        elm += this.btnSettings.replace("settingsField", "settingsCategory");
                    } else {
                        //elm += this.lblElm;
                        if (yz.id != 1 && yz.id != 2)
                            elm += this.checkElm.replace("DataCheck", `${yz.isShow ? "checked" : ""}`);
                        elm += this.inpElm.replace("DataValue", yz.settings.label).replace("DataRequired", yz.settings.required ? `&nbsp;<span class="text-danger">*</span>` : "");
                        if (yz.id == 9)
                            elm += this.btnInfo;
                        elm += this.btnSettings;
                    }
                    if (yz.id > 9)
                        elm += this.btnDelete;
                    if (ind != 0) {
                        elm += this.btnUp.replace("disabled", "");
                    } else {
                        elm += this.btnUp;
                    }

                    if (ind != this.dataList.length - 1) {
                        elm += this.btnDown.replace("disabled", "");
                    } else {
                        elm += this.btnDown;
                    }
                    elm += `</div>`
                    elmData.append(elm);
                    $(".upField").unbind("click");
                    $(".upField").on("click", function () {
                        let i = $(this).parent().attr("data-index");
                        $this.array_move(i, parseInt(i) - 1);
                        $this.renderElm();
                    });
                    $(".downField").unbind("click");
                    $(".downField").on("click", function () {
                        let i = $(this).parent().attr("data-index");
                        $this.array_move(i, parseInt(i) + 1);
                        $this.renderElm();
                    });
                    $(".deleteField").unbind("click");
                    $(".deleteField").on("click", function () {
                        let i = $(this).parent().attr("data-index");
                        $this.dataList.splice(parseInt(i), 1);
                        $this.renderElm();
                    });
                    $(".settingsField").unbind("click");
                    $(".settingsField").on("click", function () {
                        let i = $(this).parent().attr("data-index");
                        let dlg = new Nobox.AddCustomFieldDialog();
                        dlg.callback = (res: Nobox.settingsForm) => {
                            $this.dataList[i].settings = res;
                            $this.renderElm();
                        }
                        dlg.config($this.dataList[i]);
                        dlg.loadEntityAndOpenDialog($this.dataList[i].settings);
                    });
                    $(".checkField").unbind("click");
                    $(".checkField").on("change", function () {
                        let i = $(this).parent().attr("data-index");
                        $this.dataList[i].isShow = $(this).is(":checked");
                        $this.renderElm();
                    });
                })
                NioApp.BS.tooltip('[data-toggle="tooltip"]');
            } else {
                elmData.append(`<div class="field Email row px-4" data-index="2"><div class="form-control col text-ellipsis"><div class="chat-sap mx-0 py-0" style="margin: 2px 0;"><div class="chat-sap-meta" style="display: inline;"><span><b style="color:#344357;">There are no Custom Field now</b></span></div></div></div></div>`)
            }
            elmData.append(`<div class="field Add" style="float: right;gap: 3px;"><div class="btn btn-primary addCustomField">Add Custom Field</div></div>`);
            $(".addCustomField").unbind("click");
            $(".addCustomField").on("click", function () {
                let dlg = new Nobox.AddCustomFieldDialog();
                dlg.callback = (res: Nobox.settingsForm) => {
                    $this.dataList.push({ id: Math.floor(Math.random() * 1000) + 9, isShow: true, settings: res } as Nobox.form);
                    $this.renderElm();
                }
                dlg.configNew(null);
                dlg.loadNewAndOpenDialog();
            });
        }

        protected getSaveEntity() {
            var entity = super.getSaveEntity();
            entity.Data = JSON.stringify(this.dataList);
            return entity;
        }
    }
}